export const isCordova = () => {
	let pre = window.location.origin;
	return pre === 'file://' || pre === 'https://localhost' || pre === 'app://api.logrx.com'
};